export default __webpack_public_path__ + "static/media/notification_blank_icon.e4ed96ab.svg";